import React, { useState } from "react";

const MobileInvoiceWizard = ({ steps, errors }) => {
  const [activeStep, setActiveStep] = useState(0);

  if (!steps || steps.length === 0) return null;

  return (
    <div className="mobile-invoice-wizard">
      <div className="mobile-wizard-nav">
        {steps.map((step, index) => {
          const hasError = errors && step.errorKeys?.some((key) =>
            typeof key === "string"
              ? errors[key]
              : key instanceof RegExp
                ? Object.keys(errors).some((k) => key.test(k))
                : false
          );
          return (
            <div
              key={index}
              className={`mobile-wizard-nav-item${index === activeStep ? " active" : ""}${hasError ? " has-error" : ""}`}
              onClick={() => setActiveStep(index)}
            >
              <span className="step-number">{index + 1}</span>
              <span>{step.label}</span>
            </div>
          );
        })}
      </div>

      <div className="mobile-wizard-content">
        {steps[activeStep]?.content}
      </div>
    </div>
  );
};

export default MobileInvoiceWizard;
